import * as React from 'react'
import cn from 'classnames'
import { CareermindsLogo } from 'components/atoms/careerminds-logo'

export type LogoLinkProps = {
  className?: string
}

export const LogoLink: React.VFC<LogoLinkProps> = (props) => {
  const { className } = props

  return (
    <a className={cn('ml-1.5', className)} href="/">
      <CareermindsLogo />
    </a>
  )
}
